import { IAppActionReconcileClinicalLibraries, IUnifiedState } from "./interface";

/**
 * Reconciles the application-owned Clinical Library cache from loader results.
 *
 * @param state - Current unified state containing cached Clinical Libraries.
 * @param action - Clinical Library payload returned by the deferred request.
 * @returns Unified state with its Clinical Library cache reconciled.
 */
export const app_reconcileClinicalLibraries = (
  state: IUnifiedState,
  action: IAppActionReconcileClinicalLibraries,
): IUnifiedState => {
  const clinicalLibraries = { ...state.clinicalLibraries };
  action.clinicalLibraries.forEach((library) => {
    clinicalLibraries[library.hierarchyId] = library;
  });
  return { ...state, clinicalLibraries };
};
